import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/translations';
import './WhatWeDo.css';

const WhatWeDo = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <section className="what-we-do section" id="whatwedo">
      <div className="container">
        <div className="what-content">
          <h2 className="display-medium">{t.whatWeDo.title}</h2>
          <p className="body-large what-description">{t.whatWeDo.description}</p>
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
